import React from 'react';
import { FiMapPin, FiMap, FiNavigation, FiShield } from 'react-icons/fi';

const stats = [
  {
    icon: FiMapPin,
    number: '2,000+',
    target: '2000',
    label: 'Postal Codes',
  },
  {
    icon: FiMap,
    number: '9',
    target: '9',
    label: 'Provinces',
  },
  {
    icon: FiNavigation,
    number: '25',
    target: '25',
    label: 'Districts',
  },
  {
    icon: FiShield,
    number: '100%',
    target: '100',
    label: 'TypeScript',
  },
];

const Statistics = () => {
  return (
    <section className="animated-gradient py-20 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div
                key={index}
                className="stat-card bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-8 text-center"
              >
                <div className="flex justify-center mb-4">
                  <Icon className="w-8 h-8 text-white/80" />
                </div>
                <div
                  className="stat-number text-5xl font-heading font-bold text-white mb-2"
                  data-target={stat.target}
                >
                  {stat.number}
                </div>
                <div className="text-white/70 font-body text-sm uppercase tracking-wider">
                  {stat.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Statistics;
